import {createContext, useReducer,useContext} from 'react'

export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';

export const initialState = {
    show: false,
    message: ''
};

export const reducer = (state, action) => {
    switch (action.type) {
        case SHOW_CONFIRM:
            return {
                show: true,
                message: action.payload.message
            };
        case HIDE_CONFIRM:
            return {
               ...state,
               show:false
            };
        default:
            return state;
    }
};
 const ConfirmDialogContext = createContext();

function ConfirmDialogProvider({children}) {
    const [state,dispatch]=useReducer(reducer,initialState)
  return (
    <ConfirmDialogContext.Provider value={[state,dispatch]}>
        {children}
    </ConfirmDialogContext.Provider>
  )
}

export default ConfirmDialogProvider

export function useConfirmContext(){
    return useContext(ConfirmDialogContext)
}

